import { del, get, set } from 'idb-keyval'
import { parseProject } from '../model/migrate'
import { CURRENT_VERSION, type ProjectFile, type SceneDoc } from '../model/schema'

const KEY = 'megaspace:autosave'

export async function saveAutosave(doc: SceneDoc, assets: ProjectFile['assets'] = []) {
  const project: ProjectFile = { format: 'megaspace-project', version: CURRENT_VERSION, scene: doc, assets }
  try {
    await set(KEY, { savedAt: Date.now(), project })
  } catch {
    /* quota or private mode: autosave is best effort */
  }
}

/** Returns the last autosaved scene, validated and migrated; null if none or if it no longer validates. */
export async function loadAutosave(): Promise<SceneDoc | null> {
  try {
    const rec = (await get(KEY)) as { project: unknown } | undefined
    if (!rec) return null
    return parseProject(rec.project).scene
  } catch {
    return null
  }
}

export async function clearAutosave() {
  try {
    await del(KEY)
  } catch {
    /* ignore */
  }
}
